module.exports = __webpack_public_path__ + "img/tumble-dry.ae668bd6.svg";